import { useSelector } from 'react-redux';
import {
  selectBleConnectionState,
  selectBleConnectableDevices,
  selectBleConnectedDevice,
  selectBleFirmwareVersion,
  selectBleIsLocked,
  selectBleSerialNumber,
  selectBleRemoteLogFiles,
  selectBleLastConnectedDevice,
  selectBleUpdateFirmware,
  selectBleUpdateFirmwareStatus,
  selectBleSyncLog,
} from '../redux/ble/selectors';

/** @deprecated This is probably not going away, but just use the relevant selectors directly, it's more performant. */
export const useBle = () => {
  const connectableDevices = useSelector(selectBleConnectableDevices);
  const bleState = useSelector(selectBleConnectionState);
  const serialNumber = useSelector(selectBleSerialNumber);
  const firmwareVersion = useSelector(selectBleFirmwareVersion);
  const connectedDevice = useSelector(selectBleConnectedDevice);
  const isLoading = useSelector(selectBleIsLocked);
  const logFiles = useSelector(selectBleRemoteLogFiles);
  const lastConnectedDevice = useSelector(selectBleLastConnectedDevice);
  const updateFirmware = useSelector(selectBleUpdateFirmware);
  const updateFirmwareStatus = useSelector(selectBleUpdateFirmwareStatus);
  const syncLog = useSelector(selectBleSyncLog);

  return {
    connectableDevices: connectableDevices,
    connectedDevice: connectedDevice,
    serialNumber: serialNumber,
    firmwareVersion: firmwareVersion,
    bleState: bleState,
    isLoading: isLoading,
    logFiles: logFiles,
    lastConnectedDevice: lastConnectedDevice,
    updateFirmware: updateFirmware,
    updateFirmwareStatus: updateFirmwareStatus,
    syncLog: syncLog,
  };
};
